
import Vue from "vue";
import filters from "@/filters";
import directives from "@/directives";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { WebinarModel, WebinarSubscriptionInfoModel } from "@/models/webinar.model";
import { PaymentInvoiceModel } from "@/models/payment.model";
import { SCHOOL_PAYMENT_STATUS, webinarSubscriptionStatus } from "@/constants/enum.constant";
import ModalWebinarSubscribe from "@/components/webinar/ModalWebinarSubscribe.vue";
import ModalWebinarTerms from "@/components/webinar/ModalWebinarTerms.vue";
import { AxiosResponse } from "axios";

@Component({
  components: {ModalWebinarTerms, ModalWebinarSubscribe},
  directives,
  filters,
})
export default class Webinar extends Vue {
  /* VUEX */

  // ACTION
  @Action("appNewLayout")
  private appNewLayout: any;
  @Action("actionGetInvoice", {namespace: "payment"})
  private actionGetInvoice: any;
  @Action("actionGetListWebinar", {namespace: "webinar"})
  private actionGetListWebinar: any;
  @Action("actionGetSubscriptionInfo", {namespace: "webinar"})
  private actionGetSubscriptionInfo: any;
  @Action("actionGetAccess", {namespace: "webinar"})
  private actionGetAccess: any;

  // STATE
  @State("school", {namespace: "academy"})
  private school: any;
  @State("invoice", {namespace: "payment"})
  private invoice: PaymentInvoiceModel;
  @State("is_invoice", {namespace: "payment"})
  private is_invoice: boolean;
  @State("array_webinar", {namespace: "webinar"})
  private array_webinar: Array<WebinarModel>;
  @State("webinar_subscription_info", {namespace: "webinar"})
  private webinar_subscription_info: WebinarSubscriptionInfoModel;

  /* INITIALITATION */
  private showModalTerms: boolean = false;
  private showModalPayment: boolean = false;
  private canAccess: boolean = false;
  private school_payment_status = SCHOOL_PAYMENT_STATUS;
  private slideBanner = 0;
  private sliding = false;

  private get canOpenSubscribe() {
    return (
      this.webinar_subscription_info.status !== webinarSubscriptionStatus.WAITING_APPROVAL &&
      this.webinar_subscription_info.status !== webinarSubscriptionStatus.PAID
    );
  }

  private get showSubscription() {
    return (
      this.webinar_subscription_info.status !== 0 &&
      this.webinar_subscription_info.status !== webinarSubscriptionStatus.PAID
    );
  }

  private get subscriptionTextInfo() {
    if (this.webinar_subscription_info.status === webinarSubscriptionStatus.UNPAID) return this.$i18n.t("subscription_info_inactive");
    else if (this.webinar_subscription_info.status === webinarSubscriptionStatus.WAITING_APPROVAL) return this.$i18n.t("subscription_info_waiting_approval");
    else if (this.webinar_subscription_info.status === webinarSubscriptionStatus.REJECTED) return `${this.$i18n.t("subscription_info_rejected")}<br/>Note: ${this.webinar_subscription_info.note}`;
    else if (this.webinar_subscription_info.status === webinarSubscriptionStatus.PAID) return `${this.$i18n.t("subscription_info_active")} <strong>${filters.date(this.webinar_subscription_info.end_date, null)}</strong>`;
  }

  /* LIFECYCLE VUE */
  private mounted() {
    this.appNewLayout();

    setTimeout(() => {
      this.actionGetInvoice();

      if (this.school.id) {
        this.actionGetListWebinar({
          params: {school_id: this.school.id},
        });
        this.actionGetSubscriptionInfo({
          params: {
            school_id: this.school.id
          }
        });
        this.actionGetAccess({
          params: {school_id: this.school.id},
          success: (res: AxiosResponse) => {
            this.canAccess = res.data;
          },
        });
      }
    }, 500);
  }

  /* METHODS */
  private openTerms() {
      this.showModalTerms = true;
  }

  private onSlideStart(slide: any) {
    this.sliding = true;
  }

  private onSlideEnd(slide: any) {
    this.sliding = false;
  }

  private onDetailWebinar(item: WebinarModel) {
    this.$router.push({name: "detailWebinar", params: {id: String(item.id)}});
  }
}
